// extracted by mini-css-extract-plugin
var _1 = "ScrollFade__bottom--UPbyl ScrollFadeDefault__bottom--MP8Hg";
var _2 = "ScrollFade__top--D_Z9o ScrollFadeDefault__top--YIgwK";
export { _1 as "bottom", _2 as "top" }
